// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"941":"acf33b1c","988":"8758f785"}[chunkId] + ".js";
};